import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Box } from '@mui/system';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

const style = {
    'fontFamily': 'Roboto',
    'fontStyle': 'normal',
    'fontWeight': '700',
    'fontSize': '14px',
    'lineHeight': '20px',
    'color': '#3F3F3F'
}

const textStyle = {
    'fontFamily': 'Roboto',
    'fontStyle': 'normal',
    'fontSize': '14px',
    'lineHeight': '20px',
    'color': '#3F3F3F'
}

const iconStyle = {
    'color': '#5BB600',
    'margin': '5px 10px'
}

const SuccessToast = () => {

    return (
        <Alert severity='success'
            iconMapping={{
                success: <CheckCircleOutline style={iconStyle}/>,
            }}
            sx={{backgroundColor: '#D8E9C8'}}>
            <AlertTitle sx={style}>Ya está activa la nueva contraseña</AlertTitle>
            <Box sx={textStyle}>Puede ser modificada cuando sea necesario desde “Mi perfil”.</Box>
        </Alert>
    )
}

export default SuccessToast